import Background from '~/assets/images/home/contac-us-background.png'

const style = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    boxSizing: 'border-box',
    // background: theme.palette.bg.main,
    backgroundImage: `url(${Background})`,
    height: '100%',
    overflow: 'auto',
  },
  intro: {
    '@media (min-width: 720px)': {
      paddingRight: '30px',
    },
  },
  gridContainer: {
    minHeight: '100vh',
    paddingTop: theme.spacing(6),
  },
  ecoSystem: {
    textAlign: 'center',
    img: {
      maxWidth: '100%',
      maxHeight: '80vh',
    },
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    height: '90%',
  },
  rightContent: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    boxSizing: 'border-box',
    background: '#fff',
    height: '100%',
    overflow: 'auto',
  },
  featureList: {
    padding: 0,
    'list-style-type': 'none',
    marginTop: '10px',
  },
  paperWrap: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    borderRadius: 8,
    backgroundColor: 'rgb(255,255,255)',
    // boxShadow: '5px 5px rgba(0,0,0,.35)',
    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
  },
  getOTPBtn: {
    backgroundImage: `linear-gradient(to right, #0050AE 0%, #0391E8  100%)`,
  },
  checkbox: {
    span: {
      fontWeight: 600,
    },
  },
  checkBoxBtn: {
    svg: {
      color: '#c7cbd0',
    },
  },
  policy: {
    fontSize: '12px',
    marginTop: '20px',
    marginBottom: '20px',
    a: {
      'text-decoration': 'none',
    },
  },
})

export default style
